import React from "react";
import banner_img from "../../../images/banner-picture.png";
import login_logo from "../../../images/loginlogo.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputLabel, Input, InputAdornment, IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { Button } from "@mui/material";
import chevronleft from "../../../images/chevronleft.svg";
import "./Confirmacc.css";
import { userOtpVerificationApi } from "../../../Services/Login/LoginApi/loginApi";
import { useState ,useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import owl_logo from "../../../images/HOA Owl Logo.svg";
import { Link } from "react-router-dom";

function ConfirmAccComp() {
  const [digit1, setDigit1] = useState();
  const [digit2, setDigit2] = useState();
  const [digit3, setDigit3] = useState();
  const [digit4, setDigit4] = useState();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email"); // Get the email from query params

    // Define inputRefs properly
    const inputRefs = {
      digit1: useRef(null),
      digit2: useRef(null),
      digit3: useRef(null),
      digit4: useRef(null),
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      const otp = `${digit1}${digit2}${digit3}${digit4}`; // Combine the digits into one string
      try {
        const result = await dispatch(
          userOtpVerificationApi({
            otp: otp, // Send the combined OTP
            email: email,
          })
        );
        if (userOtpVerificationApi.fulfilled.match(result)) {
          navigate(`/code-verify?email=${encodeURIComponent(email)}`);
        } else {
          toast.error("Please Enter the correct OTP !");
          console.error("OTP Verification Failed", result.payload);
        }
      } catch (error) {
        console.error("Error during OTP verification", error);
      }
    };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const otp = `${digit1}${digit2}${digit3}${digit4}`; // Combine the digits into one string
  //   try {
  //     const result = await dispatch(
  //       userOtpVerificationApi({
  //         otp: otp, // Send the combined OTP
  //         email: email,
  //       })
  //     );
  //     if (userOtpVerificationApi.fulfilled.match(result)) {
  //       navigate(`/code-verify?email=${encodeURIComponent(email)}`);
  //     } else {
  //       toast.error("Please Enter the correct OTP !");
  //       console.error("OTP Verification Failed", result.payload);
  //     }
  //   } catch (error) {
  //     console.error("Error during OTP verification", error);
  //   }
  // };

  const handleChange = (event, setDigit, nextRef) => {
    const value = event.target.value.replace(/[^0-9]/g, "").slice(0, 1);
    setDigit(value);

    if (value && nextRef) {
      nextRef.current.focus();
    }
  };

  const handleKeyDown = (event, prevRef) => {
    if (event.key === "Backspace" && event.target.value === "" && prevRef) {
      prevRef.current.focus();
    }
  };


  const handleBackClick = () => {
    navigate(-1); // Navigates to the previous page
  };
  const handleloginClick = () => {
    navigate("/"); // Navigates to the previous page
  };

  return (
    <>
      <section className="login-page-one confirm-acc-section">
        <div className="container-fluid p-0">
          <div className="confirm-blk">
            <div className="login_cols_block">
              <div className="login-right-block desktop-view">
                <div className="login-logoimg text-center forgotpw-block">
                  {/* <img
                    src={login_logo}
                    alt="login-logo"
                    className="login_logo_img"
                  ></img> */}
                </div>
                <div className="back-btn">
                  <a href="javascript:void(0)" onClick={handleBackClick}>
                    <img
                      src={chevronleft}
                      alt="chevron-left"
                      class="left-icon"
                    ></img>
                    Back
                  </a>
                </div>
              </div>
              <div className="confirm-page login-box">
                <div className="login-information d-flex align-items-center flex-column">
                <div className="login-logoimg text-center">
                <Link to="/">
                    <img
                      src={owl_logo}
                      alt="login-logo"
                      className="login_logo_img"
                    />
                  </Link>
                  </div>
                  <div>
                  <h1 className="text-center m-0">Confirm your Account</h1>
                  <p className="pw-texts text-center mt-1">
                    Enter the one-time code sent to your email danny@example.com
                  </p>
                  <div className="form-login text-left">
                    <div className="mb-4">
                      {/* <div className="otp-input-container">
                        <input
                          type="number"
                          maxLength="1"
                          className="otp-input"
                          value={digit1}
                          onChange={(event) => setDigit1(event.target.value)}
                        />
                        <input
                          type="number"
                          maxLength="1"
                          className="otp-input"
                          value={digit2}
                          onChange={(event) => setDigit2(event.target.value)}
                        />
                        <input
                          type="number"
                          maxLength="1"
                          className="otp-input"
                          value={digit3}
                          onChange={(event) => setDigit3(event.target.value)}
                        />
                        <input
                          type="number"
                          maxLength="1"
                          className="otp-input"
                          value={digit4}
                          onChange={(event) => setDigit4(event.target.value)}
                        />
                      </div> */}
                       <div className="otp-input-container">
                        <input
                          ref={inputRefs.digit1}
                          type="number"
                          maxLength="1"
                          className="otp-input"
                          value={digit1}
                          onChange={(event) =>
                            handleChange(event, setDigit1, inputRefs.digit2)
                          }
                          onKeyDown={(event) => handleKeyDown(event, null)}
                        />
                        <input
                          ref={inputRefs.digit2}
                          type="number"
                          maxLength="1"
                          className="otp-input"
                          value={digit2}
                          onChange={(event) =>
                            handleChange(event, setDigit2, inputRefs.digit3)
                          }
                          onKeyDown={(event) =>
                            handleKeyDown(event, inputRefs.digit1)
                          }
                        />
                        <input
                          ref={inputRefs.digit3}
                          type="number"
                          maxLength="1"
                          className="otp-input"
                          value={digit3}
                          onChange={(event) =>
                            handleChange(event, setDigit3, inputRefs.digit4)
                          }
                          onKeyDown={(event) =>
                            handleKeyDown(event, inputRefs.digit2)
                          }
                        />
                        <input
                          ref={inputRefs.digit4}
                          type="number"
                          maxLength="1"
                          className="otp-input"
                          value={digit4}
                          onChange={(event) =>
                            handleChange(event, setDigit4, null)
                          }
                          onKeyDown={(event) =>
                            handleKeyDown(event, inputRefs.digit3)
                          }
                        />
                      </div>



                    </div>
                    <div className="btn-orange">
                      <Button onClick={handleSubmit}>Verify</Button>
                    </div>
                    <div className="lower-signup-text text-center">
                      <p>
                        Back to{" "}
                        <a href="" onClick={handleloginClick}>
                          Log In
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}

export default ConfirmAccComp;
